var OrderRowType;
(function (OrderRowType) {
    OrderRowType[OrderRowType["Part"] = 1] = "Part";
    OrderRowType[OrderRowType["Additional"] = 2] = "Additional";
    OrderRowType[OrderRowType["Sum"] = 3] = "Sum";
    OrderRowType[OrderRowType["FreeText"] = 4] = "FreeText";
})(OrderRowType || (OrderRowType = {}));
export default OrderRowType;
